import { createApi } from '@reduxjs/toolkit/query/react';
import customFetchBase from '@/app/common/utils/customFetchBase';
import { getBaseApiPath } from '@/app/common/api/config';

interface GetNotifsArgs {
  filter?: unknown;
  sort?: string;
}

type GenericBody = Record<string, unknown>;

const nocoToken = import.meta.env.VITE_NOCO_TOKEN;

const notifApi = createApi({
  reducerPath: 'notifApi',
  baseQuery: (...args) => customFetchBase(getBaseApiPath(), ...args),
  endpoints: build => ({
    getNotifs: build.query<unknown, GetNotifsArgs>({
      query: args => ({
        url: `/nocoapi/notif:list`,
        method: 'GET',
        params: {
          filter: JSON.stringify(args.filter),
          sort: args.sort
        },
        headers: {
          authorization: `Bearer ${nocoToken}`
        }
      })
    }),
    notifLog: build.mutation<unknown, GenericBody>({
      query: body => ({
        url: `/nocoapi/nofig_log:create`,
        method: 'POST',
        body,
        headers: {
          authorization: `Bearer ${nocoToken}`
        }
      })
    })
  })
});

export const { useGetNotifsQuery, useNotifLogMutation } = notifApi;

export default notifApi;
